import Cookies from 'js-cookie';
import ky from "ky";
import { nanoid } from "nanoid";
import type {
	CombinedSessionValues, CountryDetailsResponse, GetSessionValues,
	SessionValuesResponse
} from "../types/global";
import { setState } from "./store";

export const getSessionValues: GetSessionValues = async (force?: boolean) => {
	// console.log('Getting session values');

	const localStorageSessionValues = localStorage.getItem("sessionValues");

	if (localStorageSessionValues !== null && !force) {
		// console.log('Returning session values from localStorage');

		return JSON.parse(localStorageSessionValues) as CombinedSessionValues;
	}

	// console.log('Returning session values from API');

	const sessionData = await ky
		.get("/shop/ajaxwrapper.asp?fc=getsessionvaluesJSON", {
			hooks: {
				afterResponse: [
					async (request, _, response) => {
						if (response.redirected) {
							return await ky.get(request.url);
						}

						return response;
					},
				],
			},
		})
		.json<SessionValuesResponse>();

	const countryData = await ky
		.get(
			`/shop/ajaxwrapper.asp?fc=getcountrydetails&countryid=${sessionData.countryId}`,
			{
				hooks: {
					afterResponse: [
						async (request, _, response) => {
							if (response.redirected) {
								return await ky.get(request.url);
							}

							return response;
						},
					],
				},
			},
		)
		.json<CountryDetailsResponse>();

	const combinedSessionValues: CombinedSessionValues = {
		...sessionData,
		countryDetails: countryData,
	};

	localStorage.setItem("sessionValues", JSON.stringify(combinedSessionValues));

	setState((state) => {
		state.session = combinedSessionValues;
	})

	return combinedSessionValues;
};

export const getSessionId = () => {
	// return (await getSessionValues()).uniqueSessionIdentifier;
	const cookieId = Cookies.get('ds_cookie_id');

	return cookieId ? cookieId : nanoid();
};

export const getDeliveryCountry = async (force?: boolean) => {
	return (await getSessionValues(force)).countryDetails.countryCode;
};
